import { BaseLogo } from "../../../core/models/entities/BaseLogo";
import { BoxHeaderTypography } from "../Typographies/BoxHeaderTypography";
import React from "react";
import { useTranslation } from "react-i18next";
import { Design } from "../../../core/models/entities/Design";
import { Order } from "../../../core/models/entities/Order";
import { CLARITY_UNMASK, maskIfTextLogo } from "../../../utils/analytics/clarityAttrs";

export function LogoTitleHeader({ logo }: { logo: BaseLogo }) {
  const { t } = useTranslation();
  const sku = logo.product?.sku ?? "";
  const isUploadSku = sku.startsWith("UPLOAD_");

  return (
    <BoxHeaderTypography>
      {t("logo")} -{" "}
      {/* Clarity (design 5.1: attribute on the SMALLEST element): the SKU is
          a non-personal id -> unmasked in its own span so Balanced keeps it
          readable; a text/name/number logo's title is what the customer
          typed (a name on a shirt) -> masked; image logo titles stay
          visible. An UPLOAD_ sku is not shown at all. */}
      <span className={"font-medium normal-case"}>
        {!isUploadSku && (
          <>
            <span {...CLARITY_UNMASK}>{sku}</span>{" "}
          </>
        )}
        {isUploadSku ? (
          <span {...maskIfTextLogo(logo.logoType)}>{logo.title}</span>
        ) : (
          <>
            (<span {...maskIfTextLogo(logo.logoType)}>{logo.title}</span>)
          </>
        )}
      </span>
    </BoxHeaderTypography>
  );
}

export function DesignTitleHeader({ design }: { design: Design }) {
  const { t } = useTranslation();
  return (
    <BoxHeaderTypography>
      {t("design")} -{" "}
      {/* Clarity: only the MUL (non-personal id) is unmasked; the design
          title is the user's free text (may be a person's or customer's
          name) and gets no attribute (design 5.1/5.3). */}
      <span className={"font-medium normal-case"}>
        <span {...CLARITY_UNMASK}>
          {design.product?.mul ?? t("compLogoDesign.noMul")}
        </span>{" "}
        ({design.title})
      </span>
    </BoxHeaderTypography>
  );
}

export function OrderTitleHeader({ order }: { order: Order }) {
  const { t } = useTranslation();
  return (
    <BoxHeaderTypography>
      {t("order")} -{" "}
      <span className={"font-medium normal-case"} {...CLARITY_UNMASK}>
        {order.id ?? t("compLogoDesign.noId")} ({order.id})
      </span>
    </BoxHeaderTypography>
  );
}
